// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1309":"3b53517f","5692":"3b53517f","6433":"3b53517f","7287":"3b53517f","8187":"3b53517f"}[chunkId] + ".chunk.css";
};